// Imported first from the app entry, so this runs before anything else in the bundle. Tells
// `public/bootGuard.js` (loaded by the HTML shell ahead of the bundle) that the bundle executed: with
// the flag unset at `load`, the guard treats the boot as failed and reloads the page. Also closes the
// guard's attempt counter, so a later incident starts a fresh back-off.

const BOOT_RECOVERY_KEY = 'tt-boot-recovery';

declare global {
  interface Window {
    isAppBundleLoaded?: boolean;
  }
}

window.isAppBundleLoaded = true;

try {
  sessionStorage.removeItem(BOOT_RECOVERY_KEY);
} catch {
  // Private-mode storage failures are non-fatal here
}

export {};
